import { MSelectOption } from "components/Shared/MSelect";
import { QueueTypeEnum } from "interfaces/Mueller.Business.Models";

export const queueTypeCodes = {
  HOMEOWNERS_QA: "Homeowners QA",
  FIELD_APPOINTMENT: "Field Appointment",
  PREFERRED_APPOINTMENT: "Preferred Appointment",
  AUDIT_QA: "Audit QA",
  APPRAISAL_QA: "Appraisal QA",
};

export const queueTypeIds = {
  [queueTypeCodes.HOMEOWNERS_QA]: 1,
  [queueTypeCodes.FIELD_APPOINTMENT]: 3,
  [queueTypeCodes.PREFERRED_APPOINTMENT]: 4,
  [queueTypeCodes.AUDIT_QA]: 5,
  [queueTypeCodes.APPRAISAL_QA]: 2,
}

export const queueTypesToEnumMap = {
  [QueueTypeEnum.HomeownersQa]: queueTypeCodes.HOMEOWNERS_QA,
  [QueueTypeEnum.FieldAppointment]: queueTypeCodes.FIELD_APPOINTMENT,
  [QueueTypeEnum.PreferredAppointment]: queueTypeCodes.PREFERRED_APPOINTMENT,
  [QueueTypeEnum.AuditQa]: queueTypeCodes.AUDIT_QA,
};

export enum LabelType {
  QUEUE = "QUEUE",
  MAJOR_COMPANY = "MAJOR_COMPANY",
  CUSTOMER_ACCOUNT = "CUSTOMER_ACCOUNT",
  SURVEY_TYPES = "SURVEY_TYPES",
  COMPANY_SURVEY_TYPES = "COMPANY_SURVEY_TYPES",
  CUSTOMER_ACCOUNT_SURVEY_TYPES = "CUSTOMER_ACCOUNT_SURVEY_TYPES",
  EMPTY = "EMPTY",
};

export interface MSelectOptionStringValue extends MSelectOption {
  value: string;
  label: string;
}
export interface MSelectOptionNumberValue extends MSelectOption {
  value: number;
  label: string;
}

export const fieldAppointmentQueueTypeMSelectOption = {
  label: queueTypeCodes.FIELD_APPOINTMENT,
  value: queueTypeCodes.FIELD_APPOINTMENT,
};

export const preferredAppointmentQueueTypeMSelectOption = {
  label: queueTypeCodes.PREFERRED_APPOINTMENT,
  value: queueTypeCodes.PREFERRED_APPOINTMENT,
};

export const auditQAQueueTypeMSelectOption = {
  label: queueTypeCodes.AUDIT_QA,
  value: queueTypeCodes.AUDIT_QA,
};

export const homeownersQaQueueTypeMSelectOption = {
  label: queueTypeCodes.HOMEOWNERS_QA,
  value: queueTypeCodes.HOMEOWNERS_QA,
}